import {
  ActionCardModel,
  enrichActionCardWithProps,
  getAvailableTags,
  getFlowStatus,
} from '@playbooks/action-cards-utils/src'
import { ActionCard } from '@playbooks/core/src/interfaces/ActionCard'

import { Set } from '..'
import getQuestionsWithCode from '../../utils/getQuestionsWithCode'

export type SetActionCards = (data: ActionCard) => void

export default function actionSetActionCards(set: Set): SetActionCards {
  return (data: ActionCard) => {
    const { data: clonedData, flowData, availableTags, questionsWithCode } = processActionCardsData(data)

    set(state => ({
      ...state,
      data: clonedData,
      flowData,
      availableTags,
      questionsWithCode,
    }))
  }
}

export function processActionCardsData(data: ActionCard) {
  const clonedData = JSON.parse(JSON.stringify(data)) as ActionCard

  enrichActionCardWithProps(clonedData)

  const actionCardsModel = new ActionCardModel(clonedData || null!)

  const flowData = getFlowStatus(clonedData)
  const availableTags = getAvailableTags(clonedData.sections)
  const questionsWithCode = getQuestionsWithCode(actionCardsModel)

  return {
    data: clonedData,
    flowData,
    availableTags,
    questionsWithCode,
  }
}
